"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _UIIllustration = _interopRequireDefault(require("UIComponents/image/UIIllustration"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIDialogHeaderImage = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeaderImage"));

var _UIDialogFooter = _interopRequireDefault(require("UIComponents/dialog/UIDialogFooter"));

var _sources = require("ui-addon-upgrades/_core/common/data/upgradeData/properties/sources");

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var TRIAL = _sources.sourceKeys.TRIAL;
var LANG_ROUTE = 'upgrades.activationModal';

var ActivationSuccessModal = function ActivationSuccessModal(_ref) {
  var type = _ref.type,
      onSuccess = _ref.onSuccess,
      header = _ref.header,
      subText = _ref.subText;
  var isTrialModal = type === TRIAL;
  return _react.default.createElement(_UIModal.default, {
    centered: true,
    size: "auto",
    use: "success",
    width: 600
  }, _react.default.createElement(_UIDialogHeaderImage.default, {
    offsetBottom: -30,
    offsetTop: 40
  }, _react.default.createElement(_UIIllustration.default, {
    name: "success",
    width: 118
  })), _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement("h2", null, header || _react.default.createElement(_FormattedMessage.default, {
    message: LANG_ROUTE + "." + (isTrialModal ? 'trialTitle' : 'productTitle')
  }))), _react.default.createElement(_UIDialogBody.default, null, subText && _react.default.createElement("p", null, subText)), _react.default.createElement(_UIDialogFooter.default, {
    align: "center"
  }, _react.default.createElement(_UIButton.default, {
    use: "primary",
    onClick: onSuccess
  }, _react.default.createElement(_FormattedMessage.default, {
    message: LANG_ROUTE + ".getStarted"
  }))));
};

ActivationSuccessModal.propTypes = {
  type: _react.PropTypes.string.isRequired,
  onSuccess: _react.PropTypes.func,
  header: _react.PropTypes.node,
  subText: _react.PropTypes.node
};
var _default = ActivationSuccessModal;
exports.default = _default;
module.exports = exports.default;